import React from 'react';

/**
 * Calculates the number of weeks between two dates.
 */
export const calculateWeeks = (startDate?: string | null, endDate?: string | null): number => {
  if (!startDate || !endDate) return 0;
  const start = new Date(startDate);
  const end = new Date(endDate);
  const diffTime = Math.abs(end.getTime() - start.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return Math.floor(diffDays / 7);
};

/**
 * Formats a sales period with dates and week count.
 * Returns a React node with formatted date range and week count.
 */
export const formatSalesPeriod = (startDate?: string | null, endDate?: string | null): React.ReactNode => {
  if (!startDate || !endDate) return null;
  const start = new Date(startDate).toLocaleDateString('sv-SE');
  const end = new Date(endDate).toLocaleDateString('sv-SE');
  const weeks = calculateWeeks(startDate, endDate);
  return (
    <div className='flex flex-col'>
      <small>{start} - {end}</small>
      <small>({weeks} veckor)</small>
    </div>
  );
};

